import { ReactNode } from 'react';
import './Text.css';

interface TextProps {
  /**
   * Child Elements
   */
  children?: ReactNode;
  /**
   * [optional] Aditional classNames
   */
  styles?: string;
}

const Text = ({ styles = '', children }: TextProps) => (
  <p className={`text_content_p ${styles}`}>{children}</p>
);

export default Text;
